import { useMutation } from 'react-query';
import { DIGLET_URL } from '../../config';
import { useAxios, useLocalStorage } from 'shared/hooks';
import { adminSignIn, adminLogout } from 'constants/externalRoutes';
window.setLocationHref = function (url) {
    window.location.href = url;
};
var useLogout = function () {
    var token = useLocalStorage('access_token', null, false)[0];
    var axios = useAxios();
    var logoutConfig = {
        method: 'DELETE',
        headers: {
            Authorization: "Bearer ".concat(token),
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };
    var mutationOptions = {
        retry: 1,
        retryDelay: 1000,
        onSettled: function () {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('access_token_expires_at');
            localStorage.removeItem('token_type');
            localStorage.removeItem('scopes');
            localStorage.removeItem('uid');
            localStorage.removeItem('uuid');
            sessionStorage.removeItem('view_as_data');
            window.setLocationHref(adminSignIn);
        },
    };
    var mutation = useMutation(function () { return axios.delete("".concat(DIGLET_URL, "/oauth/session?source=compass"), logoutConfig); }, mutationOptions);
    return function () {
        if (process.env.REACT_APP_LOCAL_CG_ENV || process.env.JEST_WORKER_ID) {
            if (typeof token === 'string')
                mutation.mutate();
            else
                window.setLocationHref(adminSignIn);
        }
        else {
            window.setLocationHref(adminLogout);
        }
    };
};
export { useLogout };
